import get from 'transmute/get';
export const getCustomerAgentUserId = get('customerAgentUserId');
export const getExecutedActions = get('executedActions');
export const getResponse = get('response');
export const getActionName = get('actionName');
export const getExecutionStatus = get('executionStatus');
export const getCompletedAt = get('completedAt');
export const getParameters = get('parameters');